export default "__VITE_ASSET__CljxXf4U__"